import "../scss/screen.scss";
import "./plugins/navigator-saywho";

import UIkit from "uikit/dist/js/uikit-core";
import "./misc/utm";
import "./misc/date";
import "./misc/share";

// Load Lottie animation library - this is for the animated illustration card graphics
import lottie from "lottie-web";
window.lottie = lottie; // Make Lottie globally available

// ACF Gutenberg block scripts for 2024 refresh
import "./misc/appsBrowser"; // toggling tabbed content
import "./misc/solutionsAccordion"; // accordion content block
import "./misc/personCards";
import "./misc/productNavigation";
import "./misc/mainNavBlur";
import "./misc/statsCounter"; // stats module counting animations
import "./misc/heroPatternTransitions"; // hero slider animations
import "./misc/lottieAnimations"; // lottie animations on homepage

import "./misc/marketoScripts";
import heroTyping from "./misc/heroTyping";
import "./misc/blogPaginationTitles"; // Handles pagination titles on the blog

window.UIkit = UIkit;
window.UIkit.icon.add({
	x: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m15.08,2.1h2.68l-5.89,6.71,6.88,9.1h-5.4l-4.23-5.53-4.84,5.53H1.59l6.24-7.18L1.24,2.1h5.54l3.82,5.05,4.48-5.05Zm-.94,14.23h1.48L6,3.61h-1.6l9.73,12.71h0Z"/></svg>',
});

let util = UIkit.util;
window.$ = util.$;
let body = $("body");

// loads the Icon plugin
import(/* webpackChunkName: "icons" */ "uikit/dist/js/uikit-icons").then((module) => {
	UIkit.use(module.default);
});

const config = {
	// <template>: <body class regex>
	careers: "(page-template-careers|page-template-careers-job)",
	events: "archive-events", // it is technically a page, this is used not to load vue on single event pages
	webinars: "archive-webinars",
	"ai-experience": "tax-recording_type",
	//'blog': '(single-blog|post-type-archive-blog)',
	// "algolia-search": "(post-type-archive-resource|post-type-archive-webinar|post-type-archive-hol|post-type-archive-partnersolution|post-type-archive-aiaccelerator|page-template-page-partner-finder|post-type-archive-usecase)",
};

const parts_config = {
	// <part>: <class name to trigger>
	lightbox: "[uk-lightbox]",
	filter: "[uk-filter]",
	slider: "[uk-slider]",
	"content-with-video-animation": ".dr-sticky-scroll",
	"video-with-steps": ".js-videoSlider",
	"content-slider": ".dr-content-slider",
	"card-grid": ".js-card-filter",
	"trust-radius-widget": ".trustradius-tqw",
	"tabs-switcher": ".js-tabs-switcher",
	"sticky-tabs": ".js-sticky-tabs",
	"table-of-content": ".js-table-of-content",
	"nav-side-menu": ".js-nav-side-menu", //technically not a block, bot works as a block on several pages
	loadmore: ".js-load-more",
	swiper: "[swiper]",
	form: ".dr-form",
	timeline: ".dr-timeline",
	"media-text-video-autoplay": ".wp-block-media-text video",
	countup: ".js-countup-block",
	"code-snippet": ".wp-block-code",
	"image-with-caption": ".editor-content",
	search: "body",
	"blog-filter": ".post-type-archive-blog, .tax-category_blog",
};

for (let name in config) {
	let re = new RegExp(config[name]);
	if (re.test(body.classList.toString())) {
		import(/* webpackChunkName: "templates/[request]" */ "./templates/" + `${name}`)
			.then((module) => {
				module.default();
			})
			.catch((err) => {
				console.log(err);
			});
		break;
	}
}

for (let name in parts_config) {
	if (document.querySelector(parts_config[name])) {
		import(/* webpackChunkName: "parts/[request]" */ "./parts/" + `${name}`)
			.then((module) => {
				module.default();
			})
			.catch((err) => {
				console.log(err);
			});
	}
}

function loadWistia() {
	if (typeof "Wistia" !== "undefined") {
		let script = document.createElement("script");
		script.src = "https://fast.wistia.com/assets/external/E-v1.js";
		script.async = true;
		document.body.appendChild(script);
	}
}
document.addEventListener("DOMContentLoaded", function () {
	let wistiaElements = document.querySelectorAll(".js-wistia-trigger");
	if (wistiaElements.length > 0) {
		window._wq = window._wq || [];
		wistiaElements.forEach((video) => {
			video.addEventListener("click", (el) => {
				// Dynamically load Wistia JavaScript API
				// Play video after API has loaded
				let videoId = "";
				el.currentTarget.parentElement.classList.forEach((className) => {
					if (className.startsWith("wistia_async_")) {
						videoId = className.slice().slice(13);
						_wq.push({
							id: videoId,
							onReady: function (video) {
								if (video.popover != undefined) {
									video.popover.show();
								}
								video.play();
							},
						});
					}
				});
				loadWistia();
			});
		});
	}

	// Auto-click Wistia trigger on customer-template pages
	if (document.body.classList.contains("casestudy-template")) {
		const wistiaEmbedForAutoClick = document.querySelector(".wistia_embed");
		if (wistiaEmbedForAutoClick) {
			const triggerToClick = wistiaEmbedForAutoClick.querySelector(".js-wistia-trigger");
			if (triggerToClick) {
				triggerToClick.click();
			}
		}
	}

	if (
		// load if we have content with video animation block
		document.getElementsByClassName("dr-sticky-scroll").length ||
		// if we have direct link to video
		(window.location.search && window.location.search.includes("wvideo")) ||
		// if we have autoplay videos
		document.getElementsByClassName("autoPlay=true").length
	) {
		loadWistia();
	}

	if (document.body.classList.contains("home")) {
		heroTyping();
	}
});

// Add JP-specific class to <body> if "/jp/" is in the URL
document.addEventListener("DOMContentLoaded", function () {
	if (window.location.href.includes("/jp/")) {
		document.body.classList.add("jp-locale");
	}
});
